<div class="toggle-visible" [style.display]="appIsHidden ? 'none' : 'block'">
    <ng-container *ngIf="{ value: state$ | async } as stateWrapper">
        <ng-container *ngIf="stateWrapper.value as state">
            <div
                [class.container-wrapper]="viewportScaling.enabled"
                [class.supervisor-mode]="
                    state.worker?.accessLevel === WorkerAccessLevel.Supervisor || state.roundState.phase === AppPhase.TableClosed
                "
                [class.online-mode]="state.configuration.tableMode === TableMode.Online"
            >
                <div
                    class="container"
                    #container
                    (window:resize)="scaleContainer($event)"
                    [style.width]="containerWidth"
                    [style.height]="containerHeight"
                >
                    <header>
                        <div class="header-content">
                            @if (state.configuration.gameType && state.roundState.phase !== AppPhase.TableClosed) {
                                <button
                                    class="icon icon-menu"
                                    [class.icon-menu-active]="menuVisible"
                                    (click)="menuVisible = !menuVisible"
                                ></button>

                                <div class="title">
                                    <div class="text-large" i18n>{{ state.configuration.gameType | gameLabel }}</div>
                                    <div class="text-medium">
                                        <ng-container i18n>Connected players</ng-container>: {{ state.playerCount || 0 }} /
                                        <ng-container i18n>Game ID</ng-container>:
                                        {{ state.roundState.roundId ?? '-' }}
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="header-content">
                            @if (
                                state.roundState.phase !== AppPhase.TableClosed ||
                                (state.worker && state.worker.accessLevel !== WorkerAccessLevel.None)
                            ) {
                                <div class="title title-align-right">
                                    <div i18n class="text-large">
                                        {{ state.worker?.name || 'Login' }}
                                    </div>
                                    <div class="text-medium">{{ time$ | async }}</div>
                                </div>
                                <button
                                    *ngIf="
                                        state.worker?.accessLevel === WorkerAccessLevel.Supervisor &&
                                        state.supervisorState?.subPhase !== SupervisorSubPhase.ConfirmAction &&
                                        state.supervisorState?.subPhase !== SupervisorSubPhase.ConfirmGameSelection
                                    "
                                    class="icon icon-logout"
                                    [disabled]="supervisorLogoutMode"
                                    (click)="supervisorLogoutMode = true"
                                ></button>
                            }
                        </div>
                    </header>
                    <div class="body">
                        <div *ngIf="menuVisible" (click)="menuVisible = false" class="menu-container">
                            <div class="menu">
                                <div class="layer layer-menu">
                                    <ul>
                                        <li>
                                            <button i18n (click)="menuVisible = false; aboutDialogVisible = true">About game</button>
                                        </li>

                                        @if (languages.length > 0) {
                                            <li i18n class="label">Languages</li>
                                            @for (language of languages; track language.code) {
                                                <li>
                                                    <button class="no-left-bg" (click)="changeLanguage(language.code)">
                                                        <span class="unicode-icon">{{ language.flagSymbol }}</span
                                                        ><span i18n>{{ language.label }} </span>
                                                    </button>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>

                                <div class="layer layer-overlay"></div>
                            </div>
                        </div>

                        <div
                            class="main-area"
                            [class.main-area-when-sidebar-open]="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            @if (
                                state.roundState.phase === AppPhase.TableClosed &&
                                state.worker?.accessLevel !== WorkerAccessLevel.Supervisor
                            ) {
                                <app-supervisor-panel [message]="'Scan supervisor card to open table'" [showBackButton]="false" />
                            } @else if (supervisorLogoutMode) {
                                <app-supervisor-panel
                                    [inverseColors]="!supervisorLogoutMode"
                                    [message]="'Scan supervisor card to log out'"
                                    (backClicked)="supervisorLogoutMode = false"
                                />
                            } @else if (state.supervisorState) {
                                @switch (state.supervisorState.subPhase) {
                                    @case (SupervisorSubPhase.WaitingForSupervisor) {
                                        <app-supervisor-panel
                                            [inverseColors]="!supervisorLogoutMode"
                                            [message]="'Scan supervisor card to continue'"
                                            (backClicked)="cancelSupervisorAction($event)"
                                        />
                                    }

                                    @case (SupervisorSubPhase.ConfirmAction) {
                                        @switch (state.supervisorState.selectedAction) {
                                            @case (DealerConsoleAction.CloseTable) {
                                                <app-supervisor-panel
                                                    [title]="'Closing ' + gameLabel"
                                                    [message]="'Scan supervisor card to confirm changes and continue'"
                                                    (backClicked)="cancelSupervisorAction($event)"
                                                />
                                            }

                                            @case (DealerConsoleAction.ChangeShoe) {
                                                <app-supervisor-panel
                                                    [title]="'Voiding game and change shoe'"
                                                    [message]="'Scan supervisor card to confirm changes and continue'"
                                                    (backClicked)="cancelSupervisorAction($event)"
                                                />
                                            }

                                            @case (DealerConsoleAction.ChangeResult) {
                                                @if (state.supervisorState.changedGameResult) {
                                                    <app-supervisor-panel
                                                        [title]="'Result changed'"
                                                        [message]="'Scan supervisor card to confirm changes and continue'"
                                                        (backClicked)="cancelSupervisorAction($event)"
                                                    />
                                                }
                                            }
                                        }
                                    }

                                    @case (SupervisorSubPhase.GameSelection) {
                                        <app-game-selection
                                            [games]="state.games"
                                            [currentGame]="
                                                state.roundState.phase === AppPhase.TableClosed ? undefined : state.configuration.gameType
                                            "
                                            [showBackButton]="state.roundState.phase !== AppPhase.TableClosed"
                                            (backClicked)="cancelSupervisorAction($event)"
                                            (gameSelected)="selectGame($event)"
                                        />
                                    }

                                    @case (SupervisorSubPhase.ConfirmGameSelection) {
                                        <app-supervisor-panel
                                            [title]="'Selected game: ' + (state.supervisorState.selectedGameType | gameLabel)"
                                            [message]="'Scan supervisor card to confirm the selection and continue'"
                                            (backClicked)="cancelSupervisorAction($event)"
                                        />
                                    }
                                }
                            }

                            <main>
                                <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                    <app-about [backendVersion]="state.configuration.appVersion" [frontendVersion]="version"></app-about>
                                </app-modal>
                                <app-error-panel
                                    *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                    [errorCode]="state.roundState.errorCode"
                                ></app-error-panel>
                                <app-waiting-for-croupier
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"
                                ></app-waiting-for-croupier>
                                <app-waiting-for-players
                                    *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                ></app-waiting-for-players>
                                <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                <app-shoe-change *ngIf="state.roundState?.phase === AppPhase.ShoeChange"></app-shoe-change>
                                <app-burn-cards
                                    *ngIf="state.roundState?.phase === AppPhase.CardBurn"
                                    [cardValue]="state.shoeChangeState?.card"
                                    [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                                    [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                                ></app-burn-cards>
                                <app-new-round-preparation
                                    *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                ></app-new-round-preparation>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                    i18n
                                    [initialTimeInSeconds]="
                                        state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds
                                    "
                                    >Bets are open
                                </app-bets-status>
                                <app-bets-status
                                    *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                    i18n
                                    [animate]="false"
                                    [initialTimeInSeconds]="0"
                                    >Bets are closed
                                </app-bets-status>
                                <app-game-switch
                                    *ngIf="state.configuration.gameType"
                                    [gameType]="state.configuration.gameType"
                                    [tableUpdate]="state.tableUpdate"
                                    [gameResultChange]="state.gameResultChange"
                                    [appPhase]="state.roundState.phase"
                                    [subPhase]="state.roundState.subPhase"
                                >
                                    <app-result-change
                                        result-change
                                        *ngIf="
                                            state.supervisorState?.selectedAction === DealerConsoleAction.ChangeResult &&
                                            !state.supervisorState?.changedGameResult
                                        "
                                        (resultChangeConfirmed)="confirmResultChange($event)"
                                        (resultChangeClosed)="cancelSupervisorAction($event)"
                                    ></app-result-change>
                                    <app-count-down
                                        count-down
                                        *ngIf="state?.roundState?.phase === AppPhase.Decision"
                                        [initialTimeInSeconds]="state.configuration.decisionTimeInSeconds ?? 0"
                                        [animate]="true"
                                    ></app-count-down>
                                </app-game-switch>

                                @if (dealerService.gameInProgress) {
                                    <app-cut-card *ngIf="state.shoeChangeState?.cutCardDrawn"></app-cut-card>
                                }
                            </main>

                            <app-notification
                                *ngIf="notification.show"
                                [text]="notification.text"
                                [severity]="notification.severity"
                                [canClose]="notification.canClose"
                                (closeClicked)="hideNotification()"
                            ></app-notification>

                            <footer
                                [class.footer-fixed]="!dealerService.gameInProgress"
                                *ngIf="
                                    state.supervisorState?.selectedAction !== DealerConsoleAction.ChangeResult &&
                                    state.roundState?.phase !== AppPhase.WaitingForPlayers &&
                                    state.roundState?.phase !== AppPhase.RoundVoid
                                "
                            >
                                <div class="buttons-container">
                                    @if (state.supervisorState?.subPhase === SupervisorSubPhase.ActionSelection) {
                                        <div class="button-group">
                                            <button
                                                i18n
                                                class="button-game button-game-small button-small-padding"
                                                (click)="sendAction(voidGameChangeShowButton, DealerConsoleAction.ChangeShoe)"
                                                #voidGameChangeShowButton
                                            >
                                                Void game and change shoe
                                            </button>

                                            <!-- Not yet implemented on backend -->
                                            <button
                                                i18n
                                                [disabled]="true"
                                                class="button-game button-game-small button-small-padding"
                                                (click)="sendAction(voidButton, DealerConsoleAction.ChangeShoe)"
                                                #voidButton
                                            >
                                                Void game
                                            </button>
                                        </div>
                                        <button
                                            i18n
                                            [disabled]="state.roundState.phase !== AppPhase.DealingCards"
                                            class="button-game button-game-small"
                                            (click)="sendAction(changeResultButton, DealerConsoleAction.ChangeResult)"
                                            #changeResultButton
                                        >
                                            Change result
                                        </button>
                                        <div class="button-group">
                                            <button
                                                i18n
                                                [disabled]="!dealerService.gameInProgress"
                                                class="button-game button-game-small"
                                                (click)="sendAction(changeGameButton, DealerConsoleAction.ChangeGame)"
                                                #changeGameButton
                                            >
                                                Change game
                                            </button>

                                            <button
                                                i18n
                                                [disabled]="
                                                    state.flagsState.tableClosingRequested ||
                                                    state.roundState.phase === AppPhase.WaitingForCroupier ||
                                                    state.roundState.phase === AppPhase.CardBurn
                                                "
                                                class="button-game button-game-small"
                                                [class.button-game-highlight]="state.flagsState.tableClosingRequested"
                                                (click)="sendAction(closeTableButton, DealerConsoleAction.CloseTable)"
                                                #closeTableButton
                                            >
                                                Close table
                                            </button>
                                        </div>
                                    } @else if (state.worker?.accessLevel === WorkerAccessLevel.Croupier) {
                                        <button
                                            i18n
                                            class="button-game button-game-medium"
                                            (click)="sendAction(callSupervisorButton, DealerConsoleAction.CallSupervisor)"
                                            #callSupervisorButton
                                        >
                                            Call supervisor
                                        </button>

                                        <button
                                            *ngIf="state.roundState?.phase === AppPhase.ShoeChange"
                                            i18n
                                            class="button-game button-game-medium button-special"
                                            (click)="sendAction(shoeChangedButton, DealerConsoleAction.ShoeChanged)"
                                            #shoeChangedButton
                                        >
                                            Confirm
                                        </button>

                                        <!-- Not yet implemented on backend -->
                                        @if (dealerService.gameInProgress) {
                                            <!-- Confirm result button -->
                                            @if (
                                                false &&
                                                (state.roundState.phase === AppPhase.RoundEnd ||
                                                    (!state.flagsState.tableClosingRequested && !state.flagsState.gameChangingRequested))
                                            ) {
                                                <button
                                                    i18n
                                                    class="button-game button-game-medium button-special"
                                                    [disabled]="state.roundState.phase !== AppPhase.RoundEnd"
                                                    (click)="confirmResult(confirmResultButton)"
                                                    #confirmResultButton
                                                >
                                                    @if (state.flagsState.tableClosingRequested) {
                                                        Confirm Result And Close Table
                                                    } @else if (state.flagsState.gameChangingRequested) {
                                                        Confirm Result And Open New Game
                                                    } @else {
                                                        Confirm Result And Start New Hand
                                                    }
                                                </button>
                                            } @else {
                                                <!-- Supervisor action confirmed message -->
                                                @if (state.flagsState.tableClosingRequested) {
                                                    <button i18n class="button-game button-game-medium button-game-selected">
                                                        Closing table
                                                    </button>
                                                } @else if (state.flagsState.gameChangingRequested) {
                                                    <button i18n class="button-game button-game-medium button-game-selected">
                                                        Changing game to {{ state.supervisorState?.selectedGameType | gameLabel }}
                                                    </button>
                                                }
                                            }
                                        }
                                    }
                                </div>
                            </footer>
                        </div>
                        <div
                            class="sidebar"
                            *ngIf="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            <app-streaming-video
                                [videoEnabled]="!isVideoHidden"
                                [streamId]="state.configuration.videoStreamId"
                                (toggleClicked)="isVideoHidden = !isVideoHidden"
                            ></app-streaming-video>

                            <app-chat
                                [chatEnabled]="state.flagsState.chatEnabled"
                                [messages]="state.chatMessages"
                                (toggleClicked)="toggleChat($event, state.flagsState.chatEnabled)"
                            ></app-chat>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!stateWrapper.value" class="container">
            <h2 i18n class="title-vertical-center title-white">Connecting to table…</h2>
        </div>
    </ng-container>
</div>
